exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__gallery-toggle___emtOu{position:absolute;display:flex;flex-flow:column;justify-content:center;align-items:center;height:100%;width:2rem;transition:.25s;color:rgba(236,240,241,.5);background-color:rgba(44,62,80,.5);opacity:0;cursor:pointer}.styles__gallery-toggle___emtOu:hover{opacity:1}", ""]);

// exports
exports.locals = {
	"gallery-toggle": "styles__gallery-toggle___emtOu"
};